import {selector} from './selector';
import * as events from "./events";

const PageCustomerProfileTags = (function ($) {

    function initEvents() {
        $(document).on('click', selector.addTag, events.addTagModal);
        $(document).on('click', selector.addMlffTag, events.addMlffTagModal);
        $(document).on('click', selector.btnLostTag, events.openLostTagModal);
        $(document).on('click', selector.btnFoundTag, events.openFoundTagModal);
        $(document).on('click', selector.hr.tagType, events.hrTagTypeChange);
        $(document).on('click', selector.btnActivateTag, events.openActivateTagModal);
        $(document).on('click', selector.btnDeactivateTag, events.openDeactivateTagModal);
        $(document).on('click', selector.btnEditNickname, events.openEditNicknameModal);
    }

    function initialize() {
        initEvents();
    }

    return {
        init: initialize
    }
})(jQuery);

export {PageCustomerProfileTags};
